import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom'
import history from './history'
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import './index.css';
import { App } from './App';
import registerServiceWorker from './registerServiceWorker';
import { TestPage } from './TestPage'
import ReactGA from 'react-ga';

const GA_DEV_ID = 'UA-119483441-1'
ReactGA.initialize(GA_DEV_ID);

ReactDOM.render(
<BrowserRouter>
    <App/>
</BrowserRouter>, 
document.getElementById('root'));
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js